export default __webpack_public_path__ + "static/media/330_business04-fr-web.ddba4839.png";